module.exports = __webpack_public_path__ + "files/11885a3a8574213b6a77469a65e69016.png";